export default __webpack_public_path__ + "static/media/034-truck.9959d797.svg";